import React, { useEffect } from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

// Components import
import SEO from "../components/seo"
import NotificationsTable from "../components/NotificationsTable"
import InstituteCard from "../components/InstituteCard"
import AmenitiesCarousel from "../components/AmenitiesCarousel"
import NewsCard from "../components/NewsCard"
import Navbar from "../components/Navbar/Navbar"
import Footer from "../components/Footer"
import Carousel from "../components/Carousel/Carousel"
import LinkCard from "../components/LinkCard"
import Announcements from "../components/Navbar/Announcements"
import image1 from "../images/gate.jpg"
import image2 from "../images/eleclab.jpg"
import image3 from "../images/campus.jpeg"
import image4 from "../images/9.jpg"
import image5 from "../images/engineering.jpg"
import image6 from "../images/pharmacy.jpg"
import image7 from "../images/management.jpg"
import image8 from "../images/engi.jpg"
import image9 from "../images/shco.jpg"
import image10 from "../images/jrclg.jpg"
import image11 from "../images/library.jpg"
import image12 from "../images/hostel.jpg"
import image13 from "../images/labs.jpg"
import image14 from "../images/transport.jpg"
import image15 from "../images/mess.jpg"
import image16 from "../images/sport.jpg"
// Homepage
const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query{
      allMarkdownRemark (sort: { fields: [frontmatter___date], order: DESC }) {
        edges {
          node {
            frontmatter {
              title
              date
              day
              month
              description
              link
              thumbnail {
                absolutePath
              }
            }     
            fields {
              slug
            }
            internal {
              content
            }
            fileAbsolutePath    
          }
        }
      }
    }`
  )

  // To initialize announcements with data from markdown files in ../announcements/
  var announcementsArr = []
  data.allMarkdownRemark.edges.map((edge, i ) => {
    if(edge.node.fileAbsolutePath.split("/").slice(-2)[0] === "announcements")
      announcementsArr.push(edge.node.internal.content)
    return announcementsArr
    })
  const announcementsData = {
    announcements: announcementsArr
  }

  // To initialize notices with data from markdown files in ../notices_and_events/notices
  var noticesArr = []
  data.allMarkdownRemark.edges.map((edge, i ) => {
    if(edge.node.fileAbsolutePath.split("/").slice(-2)[0] === "notices")
      noticesArr.push({
        title: edge.node.frontmatter.title.toUpperCase(),
        description: edge.node.internal.content,
        day: edge.node.frontmatter.day,
        month: edge.node.frontmatter.month.toUpperCase(),
        link: edge.node.frontmatter.link
      })
    return noticesArr
    })
  const noticeBoardData = {
    heading: "Notice Board",
    links: noticesArr
  }

  // To initialize events with data from markdown files in ../notices_and_events/upcoming_events
  var eventsArr = []
  data.allMarkdownRemark.edges.map((edge, i ) => {
    if(edge.node.fileAbsolutePath.split("/").slice(-2)[0] === "upcoming_events")
      eventsArr.push({
        title: edge.node.frontmatter.title.toUpperCase(),
        description: edge.node.internal.content,
        day: edge.node.frontmatter.day,
        month: edge.node.frontmatter.month.toUpperCase(),
        link: edge.node.frontmatter.link
      })
    return eventsArr
    })
  const upcomingEventsData = {
    heading: "Upcoming Events",
    links: eventsArr
  }

  useEffect(() => {
    const script = document.createElement('script');

    script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);
  if (typeof window !== "undefined" && window.netlifyIdentity) {
    window.netlifyIdentity.on("init", user => {
      if (!user) {
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/"
        })
      }
    })
  }

  return (
  <div>
    <SEO title="Home" />
    {/* ********** Insert Components Below ********** */}
    <Announcements {...announcementsData} />
    <Navbar />
    <Carousel photos={photos}/>
    <NotificationSection>

      <NotificationsTable {...noticeBoardData} />
      <NotificationsTable {...upcomingEventsData} />
    </NotificationSection>
    <InstitutionsSection>
      <Heading>Institutions</Heading>
      <Description>Preparing students to make meaningful contributions to society as engaged citizens and leaders in a
        complex world</Description>
      <InstitutesGrid>
        {institutions.map((institute, i) => <InstituteCard key={i} {...institute} />)}
      </InstitutesGrid>
    </InstitutionsSection>
    <AmenitiesSection>
      <Heading>Student Life</Heading>
      <Description>Preparing students to make meaningful contributions to society as engaged citizens and leaders in a
        complex world</Description>
      <AmenitiesCarousel {...amenitiesData} />
    </AmenitiesSection>
    <StatisticsSection>
      <StatBox>
        <h2>29</h2>
        <p>Number of Courses</p>
      </StatBox>
      <StatBox>
        <h2>4000+</h2>
        <p>Students per AY</p>
      </StatBox>
      <StatBox>
        <h2>250</h2>
        <p>Number of Faculty</p>
      </StatBox>
      <StatBox>
        <h2>15:1</h2>
        <p>Student Faculty Ratio</p>
      </StatBox>
      <StatBox>
        <h2>100%</h2>
        <p>Placement Assistance</p>
      </StatBox>
    </StatisticsSection>
    <NewsSection>
      <Heading>Recent News</Heading>
      <Description>Preparing students to make meaningful contributions to society as engaged citizens and leaders in a
        complex world</Description>
      <NewsGrid>
        {data.allMarkdownRemark.edges.filter((edge)=> {
          if(edge.node.fileAbsolutePath.split("/").slice(-3)[0] === "news")
            return edge
          else
            return null
          }).slice(0, 4).map((edge, i ) => {
            return <NewsCard key={i} date={edge.node.frontmatter.date} title={edge.node.frontmatter.title} description={edge.node.frontmatter.description} slug={edge.node.fields.slug} pic={edge.node.frontmatter.thumbnail ? edge.node.frontmatter.thumbnail.absolutePath : null} />
            }
          )}
        </NewsGrid>
      </NewsSection>
      <ContactSection>
        <div style={{ position: "absolute", top: "-50px" }} id={"contact"}/>
        <Heading>Contact Us</Heading>
        <Description>Preparing students to make meaningful contributions to society as engaged citizens and leaders in a
          complex world</Description>
        <ContactGrid>
          <LinkCard description={""} day={"12"} month={"13"} title={"8751005005"} link={"#"}
                    blank={false} disabled={true}/>
          <LinkCard description={""} day={"12"} month={"13"} title={"info@parikrama.edu.in"}
                    link={"mailto:info@parikrama.edu.in"} blank={true}/>
          <LinkCard description={""} day={"12"} month={"13"} title={"Campus Location"} blank={true}
                    link={"https://maps.app.goo.gl/W5DtNh6oCe9Qr6jJ6"}/>
        </ContactGrid>
        {/*<ContactForm/>*/}
      </ContactSection>
      <Footer/>


      {/* ********** Components End ********** */}
    </div>
  )
}


// ********** Styled Components ********** //

// Heading used by sections
const Heading = styled.h1`

  // Margin & Padding
  margin: 0;
  padding: 0; // TODO Check
  
  // Positioning
  position: relative;
  //bottom: 2px;
  
  // Display
  //display: inline-block;
  
  // Fonts
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-6);
  line-height: 1.5;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: normal;
  
  // Border
  //border-top: 3px solid var(--textRed);
  
  // Colors
  color: var(--textRed);
  
  // Others
  z-index: 2;
  
  // Large phones and below
  @media only screen and (max-width : 544px) {


  }
`


// Description of the section
const Description = styled.p`
  
  // Spacing
  margin: 0 0 var(--spacer-4) 0;
  padding: 0;
  
  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-4);
  line-height: 1.25;
  text-align: center;
  
  // Color
  color: var(--textBlack);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    margin: 0 0 var(--spacer-3) 0;
  } 
`


// Notification Section
const NotificationSection = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-4) var(--spacer-6);
  
  // Flexbox
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--spacer-6);
  
  // Border
  //border-top: 1px solid lightgray;
  
  // Color
  background-color: var(--primaryGrey);
  
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    grid-template-columns: 1fr;
    grid-gap: var(--spacer-3);
    padding: var(--spacer-4) var(--spacer-3);
  }
`


// Institutions Section
const InstitutionsSection = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-4) var(--spacer-6) var(--spacer-6) var(--spacer-6);
  
  // Border
  //border-top: 1px solid var(--borderColor);
  
  // Color
  background-color: var(--primaryWhite);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-4) var(--spacer-3);
  }
`


// Institutes Grid
const InstitutesGrid = styled.div`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  // Grid
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; 
  grid-auto-rows: 225px;
  grid-gap: var(--spacer-4);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    grid-template-columns: 1fr; 
    grid-auto-rows: auto;
    grid-gap: var(--spacer-3);
  }
  
`


// Amenities Section
const AmenitiesSection = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-4) var(--spacer-6) var(--spacer-6) var(--spacer-6);
  
  // Border
  //border-top: 1px solid var(--borderColor);
  
  // Color
  background-color: var(--primaryGrey);
   
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-4) var(--spacer-3);
  }
`

//  - Created on July 29, 2020
const StatisticsSection = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-6) var(--spacer-6) var(--spacer-6) var(--spacer-6);
  
  // Color
  background-color: var(--primaryWhite);
  
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  //grid-gap: var(--spacer-6);
  
    & div:not(:first-child) {
    border-left: 3px solid var(--primaryRed);
  }
   
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-4) var(--spacer-3);
    grid-template-columns: 1fr;
    grid-gap: var(--spacer-3);
    
    & div {
      border-left: 3px solid var(--primaryRed);
      border-right: 3px solid var(--primaryRed);
    }
  }
    
`

//  - Created on July 29, 2020
const StatBox = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-3);
  
  // Sizing
  width: 100%;
  
  // Border
  
  //border-radius: 3px;
  
  
  
  //box-shadow: 0 0 2px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.15);
  
  background-color: var(--primaryWhite);
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-2);
  }
  
  & h2 {
    // Spacing
    margin: 0;
    padding: 0;
    
    // Font
    font-family: var(--headerFont);
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-4);
    line-height: 1.5;
    text-align: center;
    
    color: var(--textBlack)
    
  }
  
  & p {
    // Spacing
    margin: 0;
    padding: 0;
    
    // Font
    font-family: var(--headerFont);
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-2);
    line-height: 1.25;
    text-align: center;
    text-transform: uppercase;
    
    color: var(--textBlack)
    
  }
  
  
    
  
`


// News Section - Created on July 9, 2020
const NewsSection = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-4) var(--spacer-6) var(--spacer-6) var(--spacer-6);
  
  background-color: var(--primaryGrey);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-4) var(--spacer-3);
  }
`


// News Grid
const NewsGrid = styled.div`

  // Spacing
  margin: 0;
  padding: var(--spacer-2);
    
  // Grid
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: var(--spacer-4);
  
  // Others
  overflow-x: scroll;
`


// Contact Section - Created on July 10, 2020
const ContactSection = styled.div`

  // Spacing
  margin: 0;
  padding: var(--spacer-4) var(--spacer-6) var(--spacer-6) var(--spacer-6);
  
  // Positioning
  position: relative;
  
  // Colors
  background-color: var(--primaryWhite);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    padding: var(--spacer-4) var(--spacer-3);
  }
`

//  - Created on July 29, 2020
const ContactGrid = styled.div`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  // Display
  display: grid;  
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: var(--spacer-4);
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    grid-template-columns: 1fr;
    grid-gap: var(--spacer-4);
  }
  
`


// ********** Data Section ********** //

//Slider photos and quotes
const photos = [
  {
    photo: image4,
    text: "Parikrama comprises of 110 acres of lush green campus with lakes contributing to perfect harmony in the campus."
  },
  {
    photo: image3,
    text: "Parikrama comprises of 110 acres of lush green campus with lakes contributing to perfect harmony in the campus."
  },
  {
    photo: image2,
    text: "Our state of the art labs provide a great potential for research and development."
  },
  {
    photo: image1,
    text: "The breathtaking capmus with all the needfulamenities paves the way for overall development of students and prepares them for the future."
  },
  {
    photo: image5,
    text: "With over seven institutions, Parikrama contributes with a generation of well educated leaders and enthusiasts in different domains."
  }


]


// List of institutions
const institutions = [
  {
    image: image6,
    name: "ENGINEERING",
    link: "/institutions/#engineering"
  },
  {
    image: image7,
    name: "PHARMACY",
    link: "/institutions/#pharmacy"
  },
  {
    image: image8,
    name: "MANAGEMENT",
    link: "/institutions/#mba"
  },
  {
    image: image9,
    name: "POLYTECHNIC",
    link: "/institutions/#polytechnic"
  },
  {
    image: image11,
    name: "SCIENCE ACADEMY",
    link: "/institutions/#parikrama-science-academy"
  },
  {
    image: image10,
    name: "PUBLIC SCHOOL",
    link: "/institutions/#cbse-school"
  }

]


// Amenities carousel data
const amenitiesData = {
  amenities: [
    {
      id: 0,
      tab: "Library",
      image: image11,
      description: "There is a state of the art library facility available to the students with over 20,000 books and 100 journals"
    },
    {
      id: 1,
      tab: "Hostel",
      image: image12,
      description: "The Trust has started a college hostel on the campus, which caters the needs of almost 400 students; the capacity will be increased still further. The inmates of the hostel get morning and evening tea, breakfast, lunch and dinner in the college mess"
    },
    {
      id: 2,
      tab: "Labs",
      image: image13,
      description: "At parikrama we have state of the art Labs across all the institutions, which provides a good base for research and learning. "
    },
    {
      id: 3,
      tab: "Transport",
      image: image14,
      description: "Parikrama maintains an excellent fleet of comfortable, well maintained buses with trained staff. "
    },
    {
      id: 4,
      tab: "Cafeteria",
      image: image15,
      description: "At Parikrama we have a campus=wide cafeteria, which provides hygenic and tasty food for the students."
    },
    {
      id: 5,
      tab: "Sports",
      image: image16,
      description: "With encourage, we provide facilities for more than 10 sports including Football, Cricket, Horse Riding and various indoor sports."
    }
  ]
}


export default IndexPage
